export default "__VITE_ASSET__Bw5CSpce__"